module.exports = __webpack_public_path__ + "img/hero.cca281f7.jpg";